<div
  class="eventq-ptz-controls"
  [class.eventq-ptz-controls--disabled]="disabled()"
  role="group"
  aria-label="PTZ controls"
>
  <div class="eventq-ptz-controls__pad">
    <button
      type="button"
      class="eventq-ptz-controls__btn eventq-ptz-controls__btn--up"
      aria-label="Pan up"
      [disabled]="disabled()"
      (pointerdown)="onPointerDown('up', $event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
    >
      <mat-icon aria-hidden="true">keyboard_arrow_up</mat-icon>
    </button>
    <button
      type="button"
      class="eventq-ptz-controls__btn eventq-ptz-controls__btn--left"
      aria-label="Pan left"
      [disabled]="disabled()"
      (pointerdown)="onPointerDown('left', $event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
    >
      <mat-icon aria-hidden="true">keyboard_arrow_left</mat-icon>
    </button>
    <button
      type="button"
      class="eventq-ptz-controls__btn eventq-ptz-controls__btn--home"
      aria-label="PTZ home"
      [disabled]="disabled() || homeAndPresetsDisabled"
      (click)="onClickAction('home', $event)"
    >
      <mat-icon aria-hidden="true">home</mat-icon>
    </button>
    <button
      type="button"
      class="eventq-ptz-controls__btn eventq-ptz-controls__btn--right"
      aria-label="Pan right"
      [disabled]="disabled()"
      (pointerdown)="onPointerDown('right', $event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
    >
      <mat-icon aria-hidden="true">keyboard_arrow_right</mat-icon>
    </button>
    <button
      type="button"
      class="eventq-ptz-controls__btn eventq-ptz-controls__btn--down"
      aria-label="Pan down"
      [disabled]="disabled()"
      (pointerdown)="onPointerDown('down', $event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
    >
      <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
    </button>
  </div>

  <div class="eventq-ptz-controls__side">
    <button
      type="button"
      class="eventq-ptz-controls__btn"
      aria-label="Zoom in"
      [disabled]="disabled()"
      (pointerdown)="onPointerDown('zoom-in', $event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
    >
      <svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g clip-path="url(#ptz-zoom-in-clip)">
          <path d="M10.3333 9.33333H9.80667L9.62 9.15333C10.2733 8.39333 10.6667 7.40667 10.6667 6.33333C10.6667 3.94 8.72667 2 6.33333 2C3.94 2 2 3.94 2 6.33333C2 8.72667 3.94 10.6667 6.33333 10.6667C7.40667 10.6667 8.39333 10.2733 9.15333 9.62L9.33333 9.80667V10.3333L12.6667 13.66L13.66 12.6667L10.3333 9.33333V9.33333ZM6.33333 9.33333C4.67333 9.33333 3.33333 7.99333 3.33333 6.33333C3.33333 4.67333 4.67333 3.33333 6.33333 3.33333C7.99333 3.33333 9.33333 4.67333 9.33333 6.33333C9.33333 7.99333 7.99333 9.33333 6.33333 9.33333Z" fill="white"/>
          <path d="M8 6.66667H6.66667V8H6V6.66667H4.66667V6H6V4.66667H6.66667V6H8V6.66667Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="ptz-zoom-in-clip">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </button>
    <button
      type="button"
      class="eventq-ptz-controls__btn"
      aria-label="Zoom out"
      [disabled]="disabled()"
      (pointerdown)="onPointerDown('zoom-out', $event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
    >
      <svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g clip-path="url(#ptz-zoom-out-clip)">
          <path d="M10.3333 9.33333H9.80667L9.62 9.15333C10.2733 8.39333 10.6667 7.40667 10.6667 6.33333C10.6667 3.94 8.72667 2 6.33333 2C3.94 2 2 3.94 2 6.33333C2 8.72667 3.94 10.6667 6.33333 10.6667C7.40667 10.6667 8.39333 10.2733 9.15333 9.62L9.33333 9.80667V10.3333L12.6667 13.66L13.66 12.6667L10.3333 9.33333V9.33333ZM6.33333 9.33333C4.67333 9.33333 3.33333 7.99333 3.33333 6.33333C3.33333 4.67333 4.67333 3.33333 6.33333 3.33333C7.99333 3.33333 9.33333 4.67333 9.33333 6.33333C9.33333 7.99333 7.99333 9.33333 6.33333 9.33333ZM4.66667 6H8V6.66667H4.66667V6Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="ptz-zoom-out-clip">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </button>
    <button
      type="button"
      class="eventq-ptz-controls__btn"
      aria-label="PTZ presets"
      [disabled]="disabled() || homeAndPresetsDisabled"
      (click)="onClickAction('presets', $event)"
    >
      <svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g clip-path="url(#ptz-presets-clip)">
          <path d="M2 11.3333V12.6667H6V11.3333H2ZM2 3.33333V4.66667H8.66667V3.33333H2ZM8.66667 14V12.6667H14V11.3333H8.66667V10H7.33333V14H8.66667ZM4.66667 6V7.33333H2V8.66667H4.66667V10H6V6H4.66667ZM14 8.66667V7.33333H7.33333V8.66667H14ZM10 6H11.3333V4.66667H14V3.33333H11.3333V2H10V6Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="ptz-presets-clip">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </button>
  </div>
</div>
